// Copyright (c) 2016 Deere & Company

import dealerRecommendations from './dealer-recommendation-route';
import duplicatePinPlate from './duplicate-pin-plate';
import duplicatePinPlateReports from './duplicate-pin-plate-reports-route';
import factoryDuplicatePinPlate from './factory-duplicate-pin-plate-route';
import {hasAccess} from '../../shared/services/security';
import machineStatusUpdate from './machine-status-route';
import newRegistrationFormEdit from './new-registration-form-edit';
import newTransfer from './new-transfer';
import product from './products';
import productDetails from './details-route';
import productSearch from './search-route';
import productsByCustomer from './products-by-customer';
import registration from './registration-route';
import registrationProduct from './product-registration';
import reports from './reports';
import statusChangeRequest from './status-change-request-route';
import transferApprovals from './transfer-approvals-route';

export default state => {

    let redirectRouteString;

    const childRoutes = [
        duplicatePinPlate,
        duplicatePinPlateReports,
        factoryDuplicatePinPlate,
        machineStatusUpdate,
        registrationProduct,
        newRegistrationFormEdit,
        newTransfer,
        productsByCustomer,
        productSearch,
        registration,
        reports(),
        transferApprovals,
        dealerRecommendations,
        productDetails,
        statusChangeRequest
    ];

    if (hasAccess(state.user.security, 'PRT', 'PRT_DEALER_REVIEW')) {

        redirectRouteString = 'registrations';

    } else if (hasAccess(state.user.security, 'PRT', 'PRT_DLR_TRAN_APPROVE')) {

        redirectRouteString = 'transfers';

    } else if (hasAccess(state.user.security, 'PRT', 'PRT_FACTORY_USER_PIN_PLATE')) {

        redirectRouteString = 'factory-shipping-info';

    } else {

        redirectRouteString = 'search';

    }

    return {
        ...product,
        childRoutes,
        indexRoute: {onEnter: (nextState, replace) => replace(`/products/${redirectRouteString}`)}
    };

};



// WEBPACK FOOTER //
// ./src/routes/products/index.js